"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _multiDrawer = _interopRequireDefault(require("./components/multiDrawer"));
var _assigneeSelector = _interopRequireDefault(require("./components/assigneeSelector"));
var _singleDrawer = _interopRequireDefault(require("./components/singleDrawer"));
var NodeDrawer = function NodeDrawer(props) {
  var type = props.type;
  switch (type) {
    case 'single':
      return /*#__PURE__*/_react.default.createElement(_singleDrawer.default, props);
    case 'assignee':
      return /*#__PURE__*/_react.default.createElement(_assigneeSelector.default, props);
    default:
      return /*#__PURE__*/_react.default.createElement(_multiDrawer.default, props);
  }
};
NodeDrawer.propTypes = {
  type: _propTypes.default.oneOf(['single', 'assignee', 'multi']),
  t: _propTypes.default.func
};
NodeDrawer.defaultProps = {
  type: 'multi',
  t: function t(x) {
    return x;
  }
};
var _default = NodeDrawer;
exports.default = _default;